const LABELS = {
  tr: { identity: 'Kayıtlı kişisel bilgi', email: 'E-posta', phone: 'Telefon', id: 'Kimlik numarası', iban: 'IBAN', address: 'Adres', private: 'Özel bilgi' },
  en: { identity: 'Known personal information', email: 'Email', phone: 'Phone', id: 'Identification number', iban: 'IBAN', address: 'Address', private: 'Private information' },
  fr: { identity: 'Information personnelle connue', email: 'E-mail', phone: 'Téléphone', id: 'Numéro d’identité', iban: 'IBAN', address: 'Adresse', private: 'Information privée' },
};
// Read only server-produced masking markers, never infer entities or expose the
// original hidden values. Doctor-added [REDACTED] markers have their own list.
export function automaticPrivacyLabels(packet, locale = 'tr') {
  const counts = new Map();
  const markers = /\[(KİŞİ|E-POSTA GİZLENDİ|TELEFON GİZLENDİ|KİMLİK NO GİZLENDİ|IBAN GİZLENDİ|(?:PERSON|EMAIL|PHONE|ID|IBAN|ADDRESS|PRIVATE)_\d+)\]/gu;
  const group = marker => marker === 'KİŞİ' || marker.startsWith('PERSON_') ? 'identity'
    : marker.startsWith('E-POSTA') || marker.startsWith('EMAIL_') ? 'email'
      : marker.startsWith('TELEFON') || marker.startsWith('PHONE_') ? 'phone'
        : marker.startsWith('KİMLİK') || marker.startsWith('ID_') ? 'id'
          : marker.startsWith('IBAN') ? 'iban' : marker.startsWith('ADDRESS_') ? 'address' : 'private';
  function collect(value) {
    if (typeof value === 'string') {
      for (const [, marker] of value.matchAll(markers)) {
        const key = group(marker);
        counts.set(key, (counts.get(key) || 0) + 1);
      }
    } else if (Array.isArray(value)) value.forEach(collect);
    else if (value && typeof value === 'object') Object.entries(value).forEach(([key, item]) => { collect(key); collect(item); });
  }
  collect(packet);
  return [...counts].map(([key, count]) => ({ key, count, label: (LABELS[locale] || LABELS.tr)[key] }));
}
